import React from "react";

function Header() {
  const headerStyle = {
    textAlign: "center",
    marginBottom: "20px",
  };
  const nameStyle = {
    fontSize: "28px",
    fontWeight: "bold",
  };
  const contactStyle = {
    margin: "5px 0",
  };

  return (
    <header style={headerStyle}>
      <div style={nameStyle}>John Gallagher</div>
      <div style={contactStyle}>
        <strong>Email:</strong> <a href="mailto:john@gallau.com">john@gallau.com</a>
      </div>
      <div style={contactStyle}>
        <strong>LinkedIn:</strong>{" "}
        <a
          href="https://www.linkedin.com/in/gallau/"
          target="_blank"
          rel="noopener noreferrer"
        >
          linkedin.com/in/gallau/
        </a>
      </div>
    </header>
  );
}

export default Header;
